import {
    GET_LEADS_LEAD_MANAGE,
    GET_LEADS_LEAD_MANAGE_SUCCESS,
    GET_LEADS_LEAD_MANAGE_FAILURE,
    COUNT_LEADS_SUCCESS,
    COUNT_LEADS_FAILURE,
    SET_LEAD_MANAGE_KEY,
    UPDATE_LEAD_MANAGE_KEY,
    SET_LEAD_MANAGE_LOADING,
    SET_LEAD_MANAGE_PAGINATION,
    SET_LEAD_MANAGE_NEW_KEY_VALUE, TOGGLE_SHOW_LEADS_ADDITIONAL_FILTERS,
} from '../constants/get_leads.constants';

export const getLeadsRequest = ({
    filters, pagination, isLeadomatic = false, isInit = false,
} = {}) => ({
    type: GET_LEADS_LEAD_MANAGE,
    filters,
    pagination,
    isLeadomatic,
    isInit,
});

export const setLeadManageLoading = loading => ({
    type: SET_LEAD_MANAGE_LOADING,
    loading,
});

export const setLeadManagePagination = (path, value) => ({
    type: SET_LEAD_MANAGE_PAGINATION,
    path,
    payload: value,
});

export const getLeadsSuccess = leads => ({
    type: GET_LEADS_LEAD_MANAGE_SUCCESS,
    leads,
});

export const getLeadsFailure = error => ({
    type: GET_LEADS_LEAD_MANAGE_FAILURE,
    error,
});

export const countLeadsSuccess = leadsCount => ({
    type: COUNT_LEADS_SUCCESS,
    leadsCount,
});

export const countLeadsFailure = error => ({
    type: COUNT_LEADS_FAILURE,
    error,
});

export const setLeadManageKey = (path, value) => ({
    type: SET_LEAD_MANAGE_KEY,
    path,
    value,
});

export const setLeadManageNewKey = ({ data, path, value }) => ({
    type: SET_LEAD_MANAGE_NEW_KEY_VALUE,
    data,
    path,
    value,
});

export const updateLeadManageKey = data => ({
    type: UPDATE_LEAD_MANAGE_KEY,
    data,
});

export const resetTableFilters = () => ({
    type: 'LEAD_MANAGE_RESET_FILTERS',
});

export const toggleShowLeadsAdditionalFilters = () => ({
    type: TOGGLE_SHOW_LEADS_ADDITIONAL_FILTERS,
})


// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/get_leads.actions.js